import React from "react";
import { Route, Switch } from "react-router";
import ProtectedRoute from "./protectedRoutes";
import MainPage from "../components/Factory/Pages/Common/mainPage";
import forceLogout from "../components/Factory/Pages/Common/forceLogout";
import CallbackPage from "../components/Utils/Oidc/Callback";
import P_PageLayout from "./../components/Factory/Pages/Common/PageLayout/P_PageLayout";
import PageNotFound from "./PageNotFound";
import homePage from "../components/Factory/Pages/Common/homePage";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={homePage} />
      <Route path="/callback" component={CallbackPage} />
      <ProtectedRoute path="/dashboard" component={MainPage} />
      <ProtectedRoute path="/securelogout" component={forceLogout} />
      <ProtectedRoute
        path="/:pageUrl/:crmId/:templateId?"
        component={P_PageLayout}
      />
      <Route path="*" component={PageNotFound} />
    </Switch>
  );
}
